var _polygon, _rect, _rect2, _rect3, _rect4, _path, _circle, _rect5, _circle2, _path2, _path3, _circle3, _circle4, _circle5, _circle6, _polygon2, _polygon3, _polygon4, _path4, _path5, _path6, _polygon5, _rect6, _rect7, _rect8, _rect9, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartConvDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 863.91732,
    height: 364.20537,
    viewBox: "0 0 863.91732 364.20537",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "311.959 119.745 0 119.745 0 222.156 11.817 222.156 11.817 248.941 38.601 222.156 311.959 222.156 311.959 119.745",
    fill: "#f0f0f0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.66553,
    y: 129.71814,
    width: 294.62811,
    height: 81.92868,
    fill: "#4d4d4d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.72148,
    y: 154.42552,
    width: 141.85589,
    height: 4.30497,
    fill: "#f0f0f0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.72148,
    y: 169.31777,
    width: 247.24292,
    height: 4.30497,
    fill: "#f0f0f0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.72148,
    y: 184.21003,
    width: 247.00081,
    height: 4.30497,
    fill: "#f0f0f0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M692.07274,618.96676s1.487-31.15875,31.97119-27.537",
    transform: "translate(-168.04134 -267.89732)",
    fill: "#f0f0f0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 515.41796,
    cy: 306.16087,
    r: 15.2571,
    fill: "#f0f0f0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 512.9354,
    y: 331.85294,
    width: 4.30672,
    height: 30.14703,
    fill: "#f0f0f0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.92952,
    cy: 180.07338,
    r: 123.29665,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M757.348,457.86815a32.62688,32.62688,0,0,1,50.081,0,36.26372,36.26372,0,1,0-51.27085-1.18987Q756.73918,457.28694,757.348,457.86815Z",
    transform: "translate(-168.04134 -267.89732)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M855.26,457.86815a32.627,32.627,0,0,1,50.08092,0,36.26371,36.26371,0,1,0-51.2708-1.18987Q854.65117,457.28694,855.26,457.86815Z",
    transform: "translate(-168.04134 -267.89732)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.97649,
    cy: 151.39215,
    r: 12.47434,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 699.88499,
    cy: 151.39215,
    r: 12.47434,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.08341,
    cy: 210.89752,
    r: 14.50548,
    fill: "#1976d2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 744.8965,
    cy: 210.89752,
    r: 14.5055,
    fill: "#1976d2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "661.49 181.886 650.611 229.029 668.742 210.898 661.49 181.886",
    fill: "#1976d2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "717.39 363.205 705.038 352.839 705.326 363.205 701.49 363.205 701.183 352.244 684.507 363.205 677.526 363.205 701.059 347.737 700.147 315.258 699.466 290.728 703.293 290.623 703.984 315.258 704.894 347.708 723.354 363.205 717.39 363.205",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "659.363 363.205 647.012 352.839 647.3 363.205 643.474 363.205 643.167 352.244 626.49 363.205 619.509 363.205 643.033 347.737 642.122 315.258 641.441 290.728 645.276 290.623 645.967 315.258 646.868 347.708 665.328 363.205 659.363 363.205",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M836.784,315.60813c-3.3831,0-6.36764,2.628-8.36294,6.66445-1.75872-6.06969-5.45374-10.29078-9.7689-10.29078a6.56326,6.56326,0,0,0-.87094.1463c-1.65871-6.4805-5.51368-11.02542-10.00816-11.02542-6.00841,0-10.8791,8.118-10.8791,18.13187s4.87073,18.13187,10.8791,18.13187a6.56119,6.56119,0,0,0,.87093-.14629c1.65871,6.4805,5.51369,11.02541,10.00817,11.02541,3.3831,0,6.36764-2.62795,8.36294-6.66444,1.75876,6.06971,5.45374,10.29077,9.7689,10.29077,6.00841,0,10.8791-8.118,10.8791-18.13187S842.79244,315.60813,836.784,315.60813Z",
    transform: "translate(-168.04134 -267.89732)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M718.72328,451.807l-67.92039-11.01653c-3.42269-.55515-6.90789-1.11141-10.34147-.6282s-6.87069,2.1737-8.62107,5.16688a8.651,8.651,0,0,0,9.14985,12.853c-3.70741-.12023-7.60411-.19978-10.894,1.51369s-5.61946,5.87559-4.01553,9.22024a8.27667,8.27667,0,0,0,1.91922,2.4289,17.60582,17.60582,0,0,0,18.52289,3.14128c-2.50047,3.58582-7.46212,4.11838-11.7541,4.94866s-9.25362,3.258-9.41312,7.62664c-.17922,4.90869,5.66264,7.51763,10.47189,8.51687A137.41687,137.41687,0,0,0,712.648,489.3171a30.98,30.98,0,0,0,7.737-3.95049,17.43266,17.43266,0,0,0-7.05356-30.96345",
    transform: "translate(-168.04134 -267.89732)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.89005,507.47917a137.41884,137.41884,0,0,0-51.17256-57.63676,30.97519,30.97519,0,0,0-7.80737-3.80966,17.43272,17.43272,0,0,0-20.50879,24.24615l-5.31525-2.74921Q943.09323,497.98314,959.1,528.43656c1.61312,3.06929,3.26318,6.18918,5.71292,8.64309s5.86648,4.18514,9.31075,3.78525a8.6006,8.6006,0,0,0,6.77916-12.2999,16.64264,16.64264,0,0,0,5.752,5.05979c3.34648,1.59972,8.07321.9603,9.7823-2.33177a8.27455,8.27455,0,0,0,.78809-2.99368,17.60592,17.60592,0,0,0-8.62117-16.69248c4.36853-.1565,7.77622,3.48909,11.01912,6.42052,3.24327,2.93143,8.1652,5.43808,11.75289,2.94008C1015.40712,518.16062,1013.98161,511.92354,1011.89005,507.47917Z",
    transform: "translate(-168.04134 -267.89732)",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "55.757 0 506 0 506 147.807 488.945 147.807 488.945 186.463 450.289 147.807 55.757 147.807 55.757 0",
    fill: "#cacaca"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68.26381,
    y: 14.39335,
    width: 425.22943,
    height: 118.24561,
    fill: "#4d4d4d"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 102.45877,
    y: 48.91591,
    width: 204.73707,
    height: 6.21326,
    fill: "#1976d2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 102.45877,
    y: 70.40954,
    width: 356.83952,
    height: 6.21326,
    fill: "#1976d2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 102.45877,
    y: 91.90316,
    width: 356.49009,
    height: 6.21326,
    fill: "#1976d2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.95866,632.10268h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-168.04134 -267.89732)",
    fill: "#cacaca"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartConvDark);
export default __webpack_public_path__ + "static/media/start_conv_dark.ccb68ac3d429d43315bfb9af7bcb951d.svg";
export { ForwardRef as ReactComponent };